import React from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

export default function GrantProposalTab({ tabs, selectedIndex, onSelect }) {
    const controlled = selectedIndex != null && onSelect != null;
    return (
        <Tabs
            className="custom-tab1"
            {...(controlled ? { selectedIndex, onSelect } : {})}
        >
            <TabList>
                {tabs.map((tab) => (
                    <Tab key={tab.key}>{tab.label}</Tab>
                ))}
            </TabList>
            {tabs.map((tab) => (
                <TabPanel key={tab.key}>
                    {tab.content}
                </TabPanel>
            ))}
        </Tabs>
    );
}
